import { render, staticRenderFns } from "./noticeManage.vue?vue&type=template&id=1cd0568b&"
import script from "./noticeManage.vue?vue&type=script&lang=js&"
export * from "./noticeManage.vue?vue&type=script&lang=js&"
import style0 from "./noticeManage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports